var _rect, _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinnerPixCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "#484848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-19234 -8011C-19234 -8012.1 -19233.1 -8013 -19232 -8013H7686C7687.11 -8013 7688 -8012.1 7688 -8011V3975C7688 3976.1 7687.11 3977 7686 3977H-19232C-19233.1 3977 -19234 3976.1 -19234 3975V-8011Z",
    fill: "#EBF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_114)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1370,
    transform: "translate(-752 -814)",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -401.5,
    y: -710,
    width: 1219,
    height: 1162,
    rx: 8,
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -369,
    y: -465.5,
    width: 1154,
    height: 517,
    rx: 3.5,
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -353.5,
    y: -12,
    width: 392,
    height: 48,
    rx: 4,
    fill: "#F3F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8125 11.75C21.8125 13.4258 21.3828 15.0586 20.6523 16.5195C20.4805 16.8633 20.0938 17.0781 19.707 17.0781C19.5781 17.0781 19.4062 17.0352 19.2344 16.9492C18.7617 16.6914 18.5469 16.0469 18.8047 15.5312C19.4062 14.3711 19.75 13.125 19.75 11.75C19.75 7.23828 16.0117 3.5 11.5 3.5C10.8984 3.5 10.4688 3.07031 10.4688 2.46875C10.4688 1.91016 10.8984 1.4375 11.5 1.4375C17.1719 1.4375 21.8125 6.07812 21.8125 11.75Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -369,
    y: -465.5,
    width: 1154,
    height: 517,
    rx: 3.5,
    stroke: "#BDBDBD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-11829 -7696H7387V-7698H-11829V-7696ZM7388 -7695V3986H7390V-7695H7388ZM7387 3987H-11829V3989H7387V3987ZM-11830 3986V-7695H-11832V3986H-11830ZM-11829 3987C-11829.6 3987 -11830 3986.55 -11830 3986H-11832C-11832 3987.66 -11830.7 3989 -11829 3989V3987ZM7388 3986C7388 3986.55 7387.55 3987 7387 3987V3989C7388.66 3989 7390 3987.66 7390 3986H7388ZM7387 -7696C7387.55 -7696 7388 -7695.55 7388 -7695H7390C7390 -7696.66 7388.66 -7698 7387 -7698V-7696ZM-11829 -7698C-11830.7 -7698 -11832 -7696.66 -11832 -7695H-11830C-11830 -7695.55 -11829.6 -7696 -11829 -7696V-7698Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1370,
    fill: "white",
    transform: "translate(-752 -814)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerPixCopy);
export default __webpack_public_path__ + "static/media/spinner-pix-copy.b3c5f58f4698e1028f26d599a55eb931.svg";
export { ForwardRef as ReactComponent };